module.exports = __webpack_public_path__ + "static/bookfhr-28594a1c392b25f6fc3b93a55b98a1ff.jpg";